@if (article().categories?.length) {
  <div class="article-categories">
    <div class="flex flex-row flex-wrap gap-x-4 gap-y-2">
      @for (category of article().categories; track category) {
        <dhp-article-category-button
          [article]="article()"
          [category]="category"
          (categoryArticle)="categoryArticle.emit($event)"
        />
      }
    </div>
  </div>
}
